import React from 'react'

const Closed = ({ purpose }) => {
    const divStyle = { display: 'flex', justifyContent: 'center', alignItems: 'center', height: '40vh', fontSize: '40px', color: '' }
    const divStyle1 = { display: 'flex', justifyContent: 'center', fontSize: '40px', color: '' }
    return (
        <>
            <div className='text-danger' style={divStyle}>
                {purpose}
            </div>
            {purpose === "CHECK YOUR ELIGIBILITY" &&
                <div className='text-danger' style={divStyle1}>
                    Any Queries : contact tnleaacgcet2026@gmail.com
                </div>

            }
        </>
    )
}

export default Closed;